const keynoteSpeakersData = {
    "2026": [
      { name:"Durga Prasad Dasepalli", desc: "Senior Technical Architect, Perficient, USA", image: "/images/speakers/durga.jpg" },
      { name:"Prabhu Rengaramanujam", desc: "Senior Engineer, Guidewire Software Inc", image: "/images/speakers/prabhu.jpg" },
      { name:"Gopichand Talluri", desc: "ANNSLO TECH INC, USA", image: "/images/speakers/gopichand.jpg" },
      { name:"Ameya Chhatre", desc: "Sr. Software Engineer,  PAYPAL INC", image: "/images/speakers/ameya.jpg" }

    ]
  }

  module.exports = keynoteSpeakersData;